import DietaryBadge from '../ui/DietaryBadge';
import { useLanguage } from '../../context/LanguageContext';

export default function MenuItem({ item }) {
  const { language } = useLanguage();

  return (
    <div className="flex gap-4 p-4 bg-white dark:bg-gray-800 rounded-xl menu-item-hover">
      {/* Image */}
      <div className="w-24 h-24 sm:w-28 sm:h-28 rounded-lg overflow-hidden shrink-0">
        <img
          src={item.image}
          alt={item.name[language]}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-2 mb-1">
          <h3 className="font-semibold text-gray-900 dark:text-white text-lg leading-tight">
            {item.name[language]}
          </h3>
          <span className="text-lg font-bold text-primary-700 dark:text-primary-400 shrink-0">
            {item.price.toFixed(2).replace('.', ',')} €
          </span>
        </div>

        <p className="text-gray-600 dark:text-gray-400 text-sm mb-2 line-clamp-2">
          {item.description[language]}
        </p>

        {/* Dietary badges */}
        {item.dietary.length > 0 && (
          <div className="flex flex-wrap gap-1">
            {item.dietary.map((diet) => (
              <DietaryBadge key={diet} type={diet} size="sm" />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
